<!-- 发布科技成果 -->
<template>
  <div class="home">
    <h1>基础信息</h1>
    <div class="content1">
      <div class="form">
        <ul>
          <li>
            <h2>项目名称</h2>
            <input v-model="form.name" type="text" placeholder="请输入" />
          </li>
          <li>
            <h2>产业分类</h2>
            <!-- <input type="text" placeholder="请输入" /> -->
            <div class="sort">
              <el-select
                v-model="form.industrial_classification"
                placeholder="请选择"
                :loading="loading"
              >
                <el-option
                  v-for="item in industrialClassificationOptions"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </li>
          <li>
            <h2>发布时间</h2>
            <!-- <input type="text" placeholder="请输入" /> -->
            <div class="sort">
              <el-select
                v-model="form.year"
                placeholder="请选择"
                :loading="loading"
              >
                <el-option
                  v-for="item in yearOptions"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                />
              </el-select>
            </div>
          </li>
        </ul>
      </div>
      <div class="editor">
        <li>
          <span>项目详情</span
          ><RichTextEditor ref="detailsEditor" class="left-align-editor" />
        </li>
        <li><span>相关专利申请号</span><RichTextEditor ref="aboutEditor" /></li>
        <li><span>研发团队介绍</span><RichTextEditor ref="teamEditor" /></li>
        <li>
          <span>合作意向说明</span><RichTextEditor ref="cooperateEditor" />
        </li>
      </div>
      <div class="submit" @click="handleSubmit">提交</div>
    </div>
  </div>
</template>

<script>
import {
  getParams,
  getPublishAchievement,
  getMyAchievementDetail,
  getUpdateAchievement,
} from "../../api/userApi";
import RichTextEditor from "../RichTextEditor.vue";
export default {
  components: { RichTextEditor },
  data() {
    return {
      radio: "1",
      loading: false,
      form: {
        id: "", // 新增ID字段
        name: "",
        // industry_sector: "",
        industrial_classification: "",
        year: "",
      },
      industrialClassificationOptions: [], // 产业领域选项
      yearOptions: [],
      isEditMode: false,
    };
  },
  created() {
    this.fetchOptions();
    if (this.$route.query.id) {
      this.isEditMode = true;
      this.fetchAchievementDetail(this.$route.query.id);
    }
  },
  methods: {
    // 获取项目详情
    async fetchAchievementDetail(id) {
      try {
        this.loading = true;
        const response = await getMyAchievementDetail({ id });

        if (response.code === 1 && response.data) {
          const data = response.data;
          // 填充表单数据
          this.form = {
            id: data.id,
            name: data.name,
            // industry_sector: String(data.industrial_classification),
            industrial_classification: String(data.industry_sector),
            year: data.year,
          };

          // 设置富文本编辑器内容
          this.$nextTick(() => {
            if (data.details) this.$refs.detailsEditor.setContent(data.details);
            if (data.about) this.$refs.aboutEditor.setContent(data.about);
            if (data.team) this.$refs.teamEditor.setContent(data.team);
            if (data.cooperate)
              this.$refs.cooperateEditor.setContent(data.cooperate);
          });
        } else {
          this.$message.error(response.message || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情出错:", error);
        this.$message.error("获取详情出错");
      } finally {
        this.loading = false;
      }
    },
    async fetchOptions() {
      this.loading = true;
      try {
        const response = await getParams();
        if (response.code === 1 && response.data) {
          // 设置产业领域选项
          if (response.data.industrial_classification?.data) {
            this.industrialClassificationOptions =
              response.data.industrial_classification.data;
          }
          // 设置发布时间选项
          if (response.data.year?.data) {
            this.yearOptions = response.data.year.data;
          }
        } else {
          console.error("API响应:", response);
          this.$message.error("获取选项数据失败");
        }
      } catch (error) {
        console.error("获取选项出错:", error);
        this.$message.error("获取选项出错");
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      // 表单验证
      if (!this.form.name) {
        this.$message.error("请输入项目名称");
        return;
      }
      if (!this.form.industrial_classification) {
        this.$message.error("请选择产业分类");
        return;
      }
      if (!this.form.year) {
        this.$message.error("请选择发布时间");
        return;
      }

      try {
        // 获取富文本编辑器内容
        const formData = new FormData();

        // 添加表单数据
        formData.append("name", this.form.name);
        formData.append("industry_sector", this.form.industrial_classification);
        // formData.append(
        //   "industrial_classification",
        //   this.form.industrial_classification
        // );
        formData.append("year", this.form.year);
        formData.append("details", this.$refs.detailsEditor.getContent());
        formData.append("about", this.$refs.aboutEditor.getContent());
        formData.append("team", this.$refs.teamEditor.getContent());
        formData.append("cooperate", this.$refs.cooperateEditor.getContent());
        this.loading = true;
        let response;
        // 根据模式选择调用不同的API
        if (this.isEditMode) {
          formData.append("id", this.form.id);
          response = await getUpdateAchievement(formData);
        } else {
          response = await getPublishAchievement(formData);
        }

        if (response.code === 1) {
          this.$message.success(this.isEditMode ? "更新成功" : "发布成功");
          // 如果是编辑模式，返回上一页
          if (this.isEditMode) {
            this.$router.push("/memberCenter/my-publications");
          }
          this.resetForm();
        } else {
          this.$message.error(response.message || "发布失败");
        }
      } catch (error) {
        console.error("提交出错:", error);
        this.$message.error("提交出错");
      } finally {
        this.loading = false;
      }
    },
    // 重置表单
    resetForm() {
      this.form = {
        id: "",
        name: "",
        industrial_classification: "",
        year: "",
      };
      this.isEditMode = false;
      this.$refs.detailsEditor.clearEditorContent();
      this.$refs.aboutEditor.clearEditorContent();
      this.$refs.teamEditor.clearEditorContent();
      this.$refs.cooperateEditor.clearEditorContent();
    },
  },
};
</script>

<style scoped lang="less">
::v-deep .el-select-dropdown.el-popper {
  z-index: 99999 !important;
}
* {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
.left-align-editor ::v-deep .ql-editor {
  text-align: left !important;
}

.form {
  ul {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 12px 0 32px 0;
    padding-bottom: 0;
    li {
      // width: 33.3%;
      margin-top: 20px;
      margin-right: 80px;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      // justify-content: flex-start;
      h2 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #434343;
        margin-bottom: 15px;
        // text-align: left;
      }
      input {
        width: 259px;
        height: 43px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        border: none;
        outline: none;
        border: 1px solid #d8d9dc;
        padding-left: 13px;
        box-sizing: border-box;
      }
      input::placeholder {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #b1b1b1;
      }
      img {
        width: 109px;
        height: 109px;
        cursor: pointer;
      }
      .sort {
        ::v-deep .el-input__inner {
          width: 259px;
          height: 43px;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #d8d9dc;
          padding: 0 13px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #121212;
        }
        ::v-deep .el-input__inner::placeholder {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #b1b1b1;
        }
      }
    }
  }
}
.home {
  padding-bottom: 56px;
  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #434343;
    line-height: 28px;
    text-align: left;
    margin-left: 20px;
    margin-top: 20px;
  }
  .content1 {
    margin: 0 35px;

    .editor {
      border-bottom: 1px solid #dedede;
      padding-bottom: 32px;
      li {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        position: relative;
        z-index: 10;
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #434343;
          text-align: left;
          margin-bottom: 15px;
        }
      }
    }
    .submit {
      cursor: pointer;
      width: 83px;
      height: 42px;
      background: #233cac;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      line-height: 42px;
      border-radius: 5px;
      margin-top: 45px;
    }
  }
}
</style>
